// @flow
import React from 'react'
import I18n from 'i18n-react'

import IconValueComponent from './IconValueComponent'

import type QuoteInstance from '../Controllers/QuoteInstance'

type PanelProps = {
  id?: string,
  name?: string,
  keys: Array<string>,
  content: {
    [key: string]: {
      [key: string]: string
    }
  },
  quote: QuoteInstance,
  insurance: {
    info: string,
    icon: string
  },
  insuranceStart: string,
  insuranceEnd: string,
  destinationCountry: string
}

export default class Panel extends React.Component<PanelProps> {
  static defaultProps = {
    keys: []
  }

  render = () => {
    return (
      <div
        className='container p-3'
        id={this.props.id}
      >
        <h2>{I18n.translate('insurancePanel.chosenInsuranceTitle')}</h2>
        <div className='d-flex flex-wrap'>
					<span className='col-sm-2'>
						<img src={this.props.insurance.icon}/>
					</span>
          <span className='col-sm-6'>{this.props.insurance.info}</span>
          <span className='col-sm-2'>{I18n.translate('insurancePanel.basis')}</span>
          <span className='col-sm-2'>{this.props.quote.price}</span>
        </div>
        <h2>{I18n.translate('insurancePanel.includedInInsuranceTitle')}</h2>
        <div className='row'>
          {this.props.keys.map((key, index) => {
            const content = this.props.content[key]
            return (
              <div className='p-3' key={index}>
                <IconValueComponent
                  horizontal={content.horizontal}
                  src={content.svg}
                  text={content.text}
                  textMode={content.textMode}
                />
              </div>
            )
          })}
        </div>
        <div className='row'>
          <span
            className='col-sm-3'>{`${I18n.translate('insurancePanel.destinationCountry')}: ${this.props.destinationCountry}`}</span>
          <span
            className='col-sm-3'>{`${I18n.translate('insurancePanel.insuranceStart')}: ${this.props.insuranceStart}`}</span>
          <span
            className='col-sm-3'>{`${I18n.translate('insurancePanel.insuranceEnd')}: ${this.props.insuranceEnd}`}</span>
        </div>
      </div>
    )
  }
}
